'use client';
import { useRef } from 'react';
import mapObjectToEntries from '../utils/map-object-to-entries.js';
export default function useShallowMemo(obj) {
    const objRef = useRef(obj);
    for (const [key, value] of mapObjectToEntries(obj)) {
        if (objRef.current[key] !== value) {
            objRef.current = obj;
            return obj;
        }
    }
    return objRef.current;
}
//# sourceMappingURL=use-shallow-memo.js.map